import React from 'react';
import { View, Text, TextInput, Pressable, StyleSheet, TextInputProps, ViewStyle, TextStyle, Platform } from 'react-native';
import { SVG_COMPONENTS } from '@/assets/admin';
import { ADMIN_COLORS } from '@/constants/admin';

export interface PasswordInputProps extends Omit<TextInputProps, 'secureTextEntry'> {
  label?: string;
  showPassword: boolean;
  onToggleVisibility: () => void;
  containerStyle?: ViewStyle;
  labelStyle?: TextStyle;
  inputStyle?: TextStyle;
  errorMessage?: string;
}

export const PasswordInput: React.FC<PasswordInputProps> = ({
  label,
  showPassword,
  onToggleVisibility,
  containerStyle,
  labelStyle,
  inputStyle,
  errorMessage,
  ...textInputProps
}) => {
  return (
    <View style={[styles.container, containerStyle]}>
      {label && (
        <Text style={[styles.label, labelStyle]}>{label}</Text>
      )}
      <View style={styles.passwordWrapper}>
        <TextInput
          {...textInputProps}
          style={[styles.input, inputStyle, errorMessage && styles.inputError]}
          secureTextEntry={!showPassword}
          autoCapitalize="none"
          autoComplete="new-password"
        />
        <Pressable
          style={styles.eyeButton}
          onPress={onToggleVisibility}
        >
          {showPassword ? (
            <SVG_COMPONENTS.EYE_OPEN width={20} height={20} fill={ADMIN_COLORS.TEXT_SECONDARY} />
          ) : (
            <SVG_COMPONENTS.EYE_CLOSED width={20} height={20} fill={ADMIN_COLORS.TEXT_SECONDARY} />
          )}
        </Pressable>
      </View>
      {errorMessage && (
        <Text style={styles.errorText}>{errorMessage}</Text>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: 20,
  },
  label: {
    fontSize: 14,
    fontWeight: '500',
    color: ADMIN_COLORS.TEXT.PRIMARY,
    marginBottom: 8,
  },
  passwordWrapper: {
    position: 'relative',
    flexDirection: 'row',
    alignItems: 'center',
  },
  input: {
    flex: 1,
    height: 44,
    borderWidth: 1,
    borderColor: ADMIN_COLORS.INPUT.BORDER,
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingRight: 44, // Space for eye button
    fontSize: 16,
    color: ADMIN_COLORS.TEXT.PRIMARY,
    backgroundColor: ADMIN_COLORS.INPUT.PRIMARY,
    ...Platform.select({
      web: {
        outlineStyle: 'none' as any,
      },
    }),
  },
  inputError: {
    borderColor: ADMIN_COLORS.TEXT.ERROR,
  },
  eyeButton: {
    position: 'absolute',
    right: 12,
    padding: 4,
    justifyContent: 'center',
    alignItems: 'center',
  },
  errorText: {
    fontSize: 12,
    color: ADMIN_COLORS.TEXT.ERROR,
    marginTop: 4,
  },
});

